/*! @azure/msal-common v15.13.0 2025-09-24 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.13.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
